import { createApp } from 'vue'
import App from './App.vue'

// 创建Vue应用
const app = createApp(App)

// 挂载应用
app.mount('#app')